// Client helper for the newsletter signup. Posts to the in-app API route,
// which validates and forwards to the configured backend. Returns a typed
// result so the UI can show real success / error states.

export interface SubscribeResult {
  ok: boolean;
  message: string;
}

export async function subscribeNewsletter(email: string, honeypot = ''): Promise<SubscribeResult> {
  try {
    const res = await fetch('/api/newsletter', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, company: honeypot }),
    });

    const data = (await res.json().catch(() => ({}))) as Partial<SubscribeResult>;

    return {
      ok: res.ok && data.ok !== false,
      message:
        data.message || (res.ok ? 'You’re subscribed!' : 'Subscription failed. Please try again.'),
    };
  } catch {
    return { ok: false, message: 'Network error. Please check your connection and try again.' };
  }
}
